import _ from 'lodash';
import SportsApiHome from './containers/SportsApiHome';

export default SportsApiHome;

export { default as LeagueTeamFilter } from './LeagueTeamFilter/LeagueTeamFilter';

export const getProviderFriendlyName = provider => {
  switch (provider) {
    case 'sportsdata':
      return 'Sports Data';

    case 'sportradar':
      return 'Sport Radar';

    default:
      return _.capitalize(provider);
  }
};
